import React from "react";
import Grid2 from "@mui/material/Grid2";

import SummaryCard from "./summaryCard";
import HistoryIcon from "@mui/icons-material/History";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import SearchIcon from "@mui/icons-material/Search";

const SummaryCards = ({ summary }) => {
  return (
    <Grid2 container spacing={2} sx={{ mb: 3 }}>
      <Grid2 size={{ xs: 12, sm: 6, md: 2.4 }}>
        <SummaryCard
          title="Total Logs"
          value={summary.total}
          icon={<HistoryIcon />}
          color="#0f766e"
          bg="#ecfeff"
        />
      </Grid2>

      <Grid2 size={{ xs: 12, sm: 6, md: 2.4 }}>
        <SummaryCard
          title="Views"
          value={summary.views}
          icon={<VisibilityIcon />}
          color="#1565c0"
          bg="#eff6ff"
        />
      </Grid2>

      <Grid2 size={{ xs: 12, sm: 6, md: 2.4 }}>
        <SummaryCard
          title="Actions"
          value={summary.actions}
          icon={<TouchAppIcon />}
          color="#7b1fa2"
          bg="#faf5ff"
        />
      </Grid2>

      <Grid2 size={{ xs: 12, sm: 6, md: 2.4 }}>
        <SummaryCard
          title="Search"
          value={summary.searches}
          icon={<SearchIcon />}
          color="#ef6c00"
          bg="#fff7ed"
        />
      </Grid2>

      <Grid2 size={{ xs: 12, sm: 6, md: 2.4 }}>
        <SummaryCard
          title="Errors"
          value={summary.errors}
          icon={<ErrorOutlineIcon />}
          color="#c62828"
          bg="#fff1f2"
        />
      </Grid2>
    </Grid2>
  );
};

export default SummaryCards;
